import { useKakaoModal } from "src/hooks/useKakaoModal";

export const ReasonSection = () => {
  const { onClickHandler } = useKakaoModal();
  return (
    <section className="px-[16px] tablet:px-[32px] py-[80px] flex flex-col items-center gap-[32px] bg-[#E6ECF2] desktop:gap-[36px] desktop:py-[76px]">
      <div className="text-center flex flex-col gap-[8px] desktop:gap-[20px]">
        <div className="text-heading-1-mb desktop:text-heading-1">
          채권도시에서 하셔야 하는 이유
        </div>
        <div className="text-body-1-mb tablet:text-body-2-mb desktop:text-body-1">
          아직 고민되고 망설여지시나요?
        </div>
      </div>
      <div className="grid grid-cols-1 gap-[24px] items-center tablet:grid tablet:grid-cols-2 tablet:gap-[24px] desktop:w-[1140px]">
        <div className="flex py-[16px] gap-[16px]  items-center px-[24px] w-full  bg-white rounded-[24px] desktop:px-[32px] desktop:py-[24px] ">
          <img
            src="https://vws-front-store.s3.ap-northeast-2.amazonaws.com/landing/reasons/reason-1.webp"
            width="65px"
            alt="reason-1"
            loading="lazy"
            decoding="async"
          />
          <div>
            <div className="text-heading-3-mb desktop:text-heading-3">
              {/* ⅒  */}
              1/10 수준의 비용으로 채권 추심
            </div>
            <div className="text-body-3-mb tablet:text-body-3-mb">
              수임료 최대 지원시 10만원부터 소송 가능{" "}
            </div>
          </div>
        </div>
        <div className="flex py-[16px] gap-[16px]  items-center px-[24px] w-full  bg-white rounded-[24px] desktop:px-[32px] desktop:py-[24px] ">
          <img
            src="https://vws-front-store.s3.ap-northeast-2.amazonaws.com/landing/reasons/reason-2.webp"
            width="65px"
            alt="reason-2"
            loading="lazy"
            decoding="async"
          />
          <div>
            <div className="text-heading-3-mb desktop:text-heading-3">
              수천건의 경험 기반 높은 회수율{" "}
            </div>
            <div className="text-body-3-mb tablet:text-body-3-mb">
              풍부한 경력을 가진 변호사{" "}
            </div>
          </div>
        </div>
        <div className="flex py-[16px] gap-[16px]  items-center px-[24px] w-full  bg-white rounded-[24px] desktop:px-[32px] desktop:py-[24px] ">
          <img
            src="https://vws-front-store.s3.ap-northeast-2.amazonaws.com/landing/reasons/reason-3.webp"
            width="65px"
            alt="reason-3"
            loading="lazy"
            decoding="async"
          />
          <div>
            <div className="text-heading-3-mb desktop:text-heading-3">
              소송 및 강제집행까지 지원
            </div>
            <div className="text-body-3-mb tablet:text-body-3-mb">
              모든 법적 절차가 가능한 통합 법률 서비스
            </div>
          </div>
        </div>
        <div className="flex py-[16px] gap-[16px]  items-center px-[24px] w-full  bg-white rounded-[24px] desktop:px-[32px] desktop:py-[24px] ">
          <img
            src="https://vws-front-store.s3.ap-northeast-2.amazonaws.com/landing/reasons/reason-4.webp"
            width="65px"
            alt="reason-4"
            loading="lazy"
            decoding="async"
          />
          <div>
            <div className="text-heading-3-mb desktop:text-heading-3">
              간편하고 정확한 온라인 상담{" "}
            </div>
            <div className="text-body-3-mb tablet:text-body-3-mb">
              직접 찾아가지 않아 편하고 정확한 상담{" "}
            </div>
          </div>
        </div>
      </div>
      <div
        id="kakao_click"
        className="py-[10px] px-[24px] bg-[#2563EB] mt-[8px] rounded-[24px] h-[48px] flex items-center justify-center cursor-pointer"
        onClick={onClickHandler}
      >
        <span className="text-botton-1 text-white">20초 상담 받기</span>
      </div>
    </section>
  );
};
